// JUST FIREBASE LOGIC, HANDLES HTTP/FIREBASE REQUESTS
// IMPORTANT	--	NO MERGE WITH REDUX LOGIC --

import { collection, doc, getDoc, getDocs, onSnapshot } from 'firebase/firestore';
import { db } from '../../firebase';
import { convertTimestampsToUnix } from '../../utils/dateUtils';

// Get all breaks for a shift
export const getAllBreaksByShiftId = async (shiftId) => {
  if (!shiftId) {
    throw new Error('Shift ID is required to get all breaks');
  }

  try {
    const breaksCollectionRef = collection(db, `shifts/${shiftId}/breaks`);
    const querySnapshot = await getDocs(breaksCollectionRef);

    if (querySnapshot.empty) {
      console.warn(`No breaks found for shift ${shiftId}`);
      return [];
    }

    return querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...convertTimestampsToUnix(doc.data()),
    }));
  } catch (error) {
    console.error('Error fetching breaks by Shift ID:', error);
    throw error;
  }
};

// Get a single break by shift ID and break ID
export const getBreakByShiftId = async (shiftId, breakId) => {
  if (!shiftId || !breakId) {
    throw new Error('Shift ID and Break ID are required');
  }

  try {
    const breakDocRef = doc(db, `shifts/${shiftId}/breaks/${breakId}`);
    const breakDocSnap = await getDoc(breakDocRef);

    if (!breakDocSnap.exists()) {
      throw new Error(`Break with ID ${breakId} not found for shift ${shiftId}`);
    }

    return {
      id: breakDocSnap.id,
      ...convertTimestampsToUnix(breakDocSnap.data()),
    };
  } catch (error) {
    console.error('Error fetching break by Shift ID:', error);
    throw error;
  }
};

// Listen to real-time updates for all breaks in a shift
export const listenToBreaks = (shiftId, callback) => {
  if (!shiftId) throw new Error('Shift ID is required to listen to breaks');
  const breaksRef = collection(db, `shifts/${shiftId}/breaks`);
  return onSnapshot(breaksRef, (snapshot) => {
    const breaks = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...convertTimestampsToUnix(doc.data()),
    }));
    callback(breaks);
  });
};
